import ProjectCard from '../../Projects/ProjectCard/ProjectCard';
import './RelatedProjects.css';

export default function RelatedProjects({ projects }) {
  if (!projects || !projects.length) return null;

  return (
    <section className="pd-section pd-related">
      <p className="pd-eyebrow">More from NimbleCasa</p>
      <h2 className="pd-title">Explore other <em>projects</em></h2>

      <div className="pd-related__grid">
        {projects.map((project) => (
          <ProjectCard key={project.slug} project={project} />
        ))}
      </div>
    </section>
  );
}
